import './item.css';

import { Link } from 'react-router-dom';
import React, { useContext } from 'react';
// import { CartContext } from '../../context/CartContext';

const Hw3Item = ({ info }) => {
    // const nombre =useContext(CartContext);

    return (
      // <Link to={`/detalle/${info.id}`} className="film">
            <Link to={`/detalle/${info.id}`}>
              <div style={{
                padding: "2px 4px 5px",
                // height: 60,
              backgroundColor: "#b7e780",
              color: "black",
              display: "flex",
              justifyContent: "center",
              alignItems: "left",
              fontWeight: "bold",
              }}>
              {info.title}
              </div>
           
            <img src={info.image} alt="" className="film"/>
            </Link>
    );
}

export default Hw3Item;